import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync, useReloadOnOutletSave, useRequiredParams } from "../../../utilities/customHooks";
import LoadingIndicator from "../../../Components/LoadingIndicator";
import ErrorIndicator from "../../../Components/ErrorIndicator";
import { getMemberDetails, growthCoachByapplication, updateApplicationStatus, setIpeStatus, createNewProject, sendSowFeedback, updatedRejectionProg, rejectionEmailTrigger, applicationEditRequest, ipeReject, intiateSowRequest, submitSpf, adminApproveSow, sowSigned, rejectFlagForApplication, adminRevokeSowApproval } from "../../../services/adminService";
import * as T from "../../../utilities/frontendTypes";
import FormGroup from "../../../Components/FormGroup";
import { convertFounderProfileDBStateToUIState } from "../../../utilities/stateConverters";
import { addressFormDefinition, founderProfileEvaluationFormGroupDefinition, gcRejectFormDefinition, sowFeedbackFormDefinition, t1AssessmentForm, t2CoachAssessmentForm, t2ServiceAssessmentForm, t3serviceAssessmentForm, updatedFounderProfileEvaluationFormGroupDefinition, updatedFounderProfileReadinessEvaluationFormGroupDefinition } from "../../../utilities/formDefinitionTemplates";
import { allt2Services, allt3Services, daysAgo, flattenObject, getModifiedCompanyInfoFormDef, isFromUrls, returnFounderStatusStrings } from "../../../utilities/helperFunctions";
import { SetStateAction, useContext, useEffect, useState } from "react";
import CompanyNotes from "../../../Components/AdminNotes";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from "react-accessible-accordion";
import Plus from '../../../assets/Plus.png'
import Minus from '../../../assets/Minus.png'
import Form, { FormDefinition, FormData, FieldDefinition } from "../../../Components/Form/Form";
import moment from "moment";
import Modal from "../../../Components/Modal";
import PdfDownloader from "../../../Components/Form/pdfDisplay";
import Button, { ButtonProp } from "../../../Components/Button";
import { basic_text_validator, selection_validator } from "../../../utilities/formFieldValidators";
import { inputClasses } from "../../../Components/Form/InputField";
import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import leaf from '../../../assets/Group.png'
import ctLogoText from '../../../assets/Group-1.png'
import { needHelpWithDefinition, profileFormAdminProgramingEvaluationDefinition, profileFormPersonalInfoDefinition, profileFormProgramingEvaluationDefinition } from "../../../utilities/profileFormDefitions";

function MemberDetails () {
  const { logout } = useContext(AuthContext) as AuthContextType;
  const memberId = useRequiredParams("memberId");
  const navigate = useNavigate();
  const [html, setHtml] = useState(<></>)
  const [reloadOnOutletSave, setReloadOnOutletSave] = useState(false);
  const [viewPdfName, setViewPdfName] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [modalHtml, setModalHtml] = useState(<></>)
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const [workingSowId, setWorkingSowId] = useState("")
  const [sowViewingArrayPosition, setSowViewingArrayPostion] = useState(0)
  const [hardCrit, setHardCrit] = useState(false)
  const [notTech, setNotTech] = useState(false)
  const [economicBenefit, setEconomicBenefit] = useState(false)
  const [revScore, setRevScore] = useState(false)
  const [marketReadiness, setMarketReadiness] = useState(false)
  const [ipOwnership, setIpOwnership] = useState(false)
  const [commercialization, setCommercialization] = useState(false)
  const [jobCreation, setJobCreation] = useState(false)
  const [teamFit, setTeamFit] = useState(false)
  const [nextStep, setNextStep] = useState("")
  const [selectSpf, setSelectSpf] = useState(false)
  const [spf, setSpf] = useState("");
  const [viewingSow, setViewingSow] = useState(false)

  const printRef = React.useRef(null)

  const handleSowDownload = async (sowTitle: string) => {
    const element = printRef.current
    if (!element) {
      return;
    }
    const canvas = await html2canvas(element)
    const data = canvas.toDataURL('image/png')
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4"
    });

    const imgProperties = pdf.getImageProperties(data)
    const pdfWidth = pdf.internal.pageSize.getWidth()
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight)
    pdf.save(sowTitle)
  }

  const handleNextStepChange = (string: string) => {
    setNextStep(string);
  };

  const companyInfoToForm = (info: T.CompanyInfo) => {
    return flattenObject({basicInfo: info.basicInfo, registration: info.registration})
  }

  const changeCriteria = (criteria: string) => {
    if (criteria === "hardCrit") {
      setHardCrit(!hardCrit)
    }
    if (criteria === "notTech") {
      setNotTech(!notTech)
    }
    if (criteria === "economicBenefit") {
      setEconomicBenefit(!economicBenefit)
    }
    if (criteria === "revScore") {
      setRevScore(!revScore)
    }
    if (criteria === "marketReadiness") {
      setMarketReadiness(!marketReadiness)
    }
    if (criteria === "ipOwnership") {
      setIpOwnership(!ipOwnership)
    }
    if (criteria === "hardCrit") {
      setHardCrit(!hardCrit)
    }
    if (criteria === "commercialization") {
      setCommercialization(!commercialization)
    }
    if (criteria === "jobCreation") {
      setJobCreation(!jobCreation)
    }
    if (criteria === "teamFit") {
      setTeamFit(!teamFit)
    }
  }

  const ddToString = (string: string) => {
    switch(string) {
      case "fail":
        return "Fail";
      case "pass":
        return "Pass";
      case "conditionalPass":
        return "Conditional Pass (followup done by Growth Coach)";
      case "issue":
        return "Ongoing Due Diligence";
      default: // undefined 
        return "No Selection Made"
    }
  }

  useEffect(() => {
    setHtml(<CompanyNotes id={memberId}/>)
  }, [memberId]);
  
  const [childClickedAccordionItemIndex, setChildClickedAccordionItemIndex] = useState(0);
  const memberDetailsAsync = useAsync(() => getMemberDetails(memberId), [reloadOnOutletSave]);

  if (memberDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (memberDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  async function submitSowFeedback (updatedForm: FormData) {
    if (memberDetailsAsync.status !== "rejected"  && memberDetailsAsync.status !== "pending") {

    const form = updatedForm as any
    const workingSow = memberDetailsAsync.value.project?.statements[sowViewingArrayPosition] as T.Statement

    const sowFeedback = form.sowFeedback as string
    showLoading();
    const response = await sendSowFeedback(sowFeedback, workingSow.sowId);
    hideLoading();
    if (response.success) {
      showToast({
        toastType: "success",
        message: "SoW Feedback Requested",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
      setIsRejectionModalOpen(false)
      setIsModalOpen(false)
    }
  }
}

  const editRequest = async () => {
    showLoading();
    const res = await applicationEditRequest(applicationDetails?._id || "")
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Application Edit Requested",
      });
      navigate("/dashboard");
    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }

  const flagForRejection = async () => {
    showLoading();
    const res = await rejectFlagForApplication(applicationDetails?._id || "")
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Application Flagged for rejection",
      });
      navigate("/dashboard");
    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }
  
  const memberDetails = memberDetailsAsync.value.memberDetails
  const applicationDetails = memberDetailsAsync.value.applicationDetails
  const project = memberDetailsAsync.value.project
  const multipleOpenSows = memberDetailsAsync.value.multipleOpenSows 

  async function markSowSigned () {
    if (project) {
      showLoading();
      const response = await sowSigned(project.statements[sowViewingArrayPosition].sowId);
      hideLoading();
      if (response.success) {
        showToast({
          toastType: "success",
          message: "SoW Maked as Signed!",
        });
        setReloadOnOutletSave(!reloadOnOutletSave)
        setIsRejectionModalOpen(false)
      }
    }
  }
  
  const sowFeedbackButtonProp: ButtonProp = {
    buttonText: "Submit Feedback",
    actionHandler: submitSowFeedback,
  }
  
  const sowFeedbackHTML = (
    <Form 
      formDefinition={sowFeedbackFormDefinition}
      formData={null}
      primaryButtonProp={sowFeedbackButtonProp}
    />
  )
  
  async function approveSoW (workingSowId: string) {
    showLoading();
    const response = await adminApproveSow(workingSowId);
    hideLoading();
    if (response.success) {
      showToast({
        toastType: "success",
        message: "SoW Approved!",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
      setIsRejectionModalOpen(false)
      setIsModalOpen(false)
    }
  }

  async function revokeAdminApproval () {
    if (project) {
      showLoading();
      const response = await adminRevokeSowApproval(project.statements[sowViewingArrayPosition].sowId);
      hideLoading();
      if (response.success) {
        showToast({
          toastType: "success",
          message: "SoW had been reverted to Awaiting Admin Approval!",
        });
        setReloadOnOutletSave(!reloadOnOutletSave)
        setIsRejectionModalOpen(false)
      }
    }
  }

  console.log(workingSowId)
  const viewSow = () => {
    setViewingSow(true)
    if ( memberDetailsAsync.value.project) {
      const workingSow = memberDetailsAsync.value.project.statements[sowViewingArrayPosition] as T.Statement
      const combinedArray = [...workingSow.sowItems as T.SowItem[], ...workingSow.payment as T.Payment[]];
      const sortedArray = combinedArray.sort((a, b) => new Date(a.itemDate).getTime() - new Date(b.itemDate).getTime());
      const isTier2 = workingSow.tier === "2" 
      setWorkingSowId(workingSow.sowId)
      const percentage = memberDetailsAsync.value.coInvestPercentage 
      const containerClasses = workingSow.sowStatus === "Approved & Ready for Signatures" ? "!bg-white p-4 w-full flex flex-col overflow-y-auto" : "w-full flex flex-col overflow-y-auto"
      const generateSowItemTableHtml = () => {
        const html = sortedArray.map((item, index) => {
        if (item.hasOwnProperty('category')) {
          const {category, task, taskDescription, deliverable, itemDate, costBreakdown, costBreakdownTotalTax, costBreakdownTotal, itemId} = item as T.SowItem;
          return (
            <div key={itemId} className="w-full flex gap-2 relative mb-4 mt-4  border-cSage border-b-[1px]">
              <div className="h-full flex flex-col justify-between" style={{ width: '15%', display: 'inline-flex' }}>
                <div className="mb-4">
                  <p className="flex grow break-word font-normal text-text/80 self-center capitalize">{category}</p>
                  <p className="flex grow break-word font-normal text-text/80 self-center capitalize mt-2">{task}</p>
                </div>
              </div>
              <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                <p className="">{taskDescription}</p>
              </div>
              <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                <p className="">{deliverable}</p>
              </div>
              {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                <p className="">{effort}</p>
              </div> */}
              <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
              </div>
              <div className="h-full mb-4" style={{ width: '24%', display: 'inline-block' }}>
                <ul className="w-full">
                  {costBreakdown.map((expense, index) => (
                    <li key={index} className={index === 0 ? `expenseLi w-full !p-0 border-1 border-b mb-2 border-cSage` : "expenseLi border-1 border-b !p-0 mb-2 border-cSage"}>
                      <div>
                        {expense.itemDescription}
                      </div> 
                      {
                        !expense.isLumpsum &&
                        <div className="flex w-full bodySmaller">
                          <span className="w-1/3">Hours: {expense.effort}</span>
                          <span className="w-2/3">Hourly Rate: ${expense.hourlyRate}</span>
                        </div>                           
                      }
                      <div className="flex w-full bodySmaller pb-2">
                        <span className="w-1/3">$ {expense.amount}</span>
                        <span className="w-2/3">{expense.tax === "0" ? "No Tax" : expense.tax === "0.05" ? `5% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}` : `13% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}`}  </span>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="flex flex-col gap-1">
                  <p className="">Pre-Tax: ${costBreakdownTotal.toFixed(2)}</p>
                  <p className="">Tax: ${costBreakdownTotalTax.toFixed(2)}</p>
                  <p className=""><span className="font-semibold">Total: </span>${(costBreakdownTotal + costBreakdownTotalTax).toFixed(2)}</p>
                </div>
              </div>
            </div>
          );
        } else if (item.hasOwnProperty('paymentType')) {
            const {paymentType, itemDate, coInvestDate, paymentAmount, itemId, preTax, tax} = item as T.Payment
            if (paymentType === "milestone") {
              return (
                <div key={itemId} className="w-full pb-4 mb-4 gap-2 flex border-cSage border-b-[1px]">
                  <div className="h-full flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold mb-2">Progress Milestone Payment</p>
                  </div>
                  <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                    <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                    <p className=""><span className="">{`Pre-Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                    <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                    <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                  </div>
                </div>
              );
            } else if (paymentType === "final" && isTier2) {
              return (
                <div key={itemId} className="w-full gap-2 flex pb-4 mb-4 border-cSage border-b-[1px]">
                  <div className="h-full items-center flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold mb-2">Final Payment</p>
                  </div>
                  <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                    <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '14%', display: 'inline-flex' }}>
                    <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                    <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                    <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                  </div>
              </div>
              )
            } else if (paymentType === "final" && !isTier2 && coInvestDate) {
              return (
                <div className="w-full mb-4 gap-2 flex flex-col border-cSage border-b-[1px]">
                  <div key={itemId} className="w-full gap-2 flex">
                    <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                      <p className="font-semibold mb-2">Final Payment</p>
                    </div>
                    <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                      <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                    </div>
                    <div className="h-full flex-col gap-2 justify-center border-cSage border-b-[1px]" style={{ width: '24%', display: 'inline-flex' }}>
                      <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                      <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                      <p className="pb-2"><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                    </div>
                  </div>
                  <div className="w-full flex gap-2 py-2">
                    <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                      <p className="font-semibold">Co-Invest Payment ({percentage}%)</p>
                    </div>
                    <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                      <p className="">{moment(coInvestDate).format('MMM Do YYYY').toString()}</p>
                    </div>
                    <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                      <p className=""><span className="font-semibold">{`Total: `}</span> ${preTax ? (percentage / 100 * preTax).toFixed(2) : ""}</p>
                    </div>
                  </div>
                </div>
              )
            } else {
              return <></>
            }
          }
        })
        setModalHtml(
          <div className="flex flex-col">
            {
              workingSow.sowStatus === "Edit Requested from Admin" && workingSow.adminFeedback &&
              <div>
                <div className="font-semibold bodyLarger">{workingSow.adminFeedback.map((note, index) => (
                  <div key={index}>
                    <div className="flex justify-between w-full mb-2">
                      <p>{moment(note.date).format('MMM Do YYYY').toString()}</p>
                    </div>
                    <div className="flex mt-2 mb-2">
                      <span className="notesLine">{note.feedback}</span>
                    </div>
                  </div>
                ))}
                </div>
              </div>
            }
            <div ref={printRef} id="sowApproveContainer" className={containerClasses}>
              {workingSow.sowStatus === "Approved & Ready for Signatures" &&
                <div className="w-full flex flex-col">
                  <div className=" w-full flex justify-between">
                    <div className="flex footerCTLogo !justify-start !items-end">
                      <img
                        className="ctLogoLeaf !w-[90%] !h-90%"
                        src={leaf}
                        alt="communitech Logo leaf"
                      />
                      <img
                        className="ctLogoText w-[120%] max-w-[120%]"
                        src={ctLogoText}
                        alt="communitech Logo text"
                      />
                    </div>
                    <div className="flex flex-col">
                      <p className="font-semibold">Communitech Hub&#174;</p>
                      <p>151 Charles Street West, Suite 100</p>
                      <p>Kitchener, Ontario, Canada N2G 1H6</p>
                    </div>
                  </div>
                  <h3 className="my-8 text-center">ElevateIP | {`Tier ${workingSow.tier}`} Scope of Work and Attestation of Funds Usage</h3>
                  <div className="flex flex-col font-semibold gap-1 w-full">
                    <div className="flex w-full"><p className="w-[40%]">Service Provider Name:</p> <p>{project?.spOwner?.name} - {project?.spName}</p></div>
                    <div className="flex w-full"><p className="w-[40%]">Startup Name:</p> <p>{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName}</p></div>
                    <div className="flex w-full"><p className="w-[40%]">Date:</p> <p>{moment(new Date()).format('MMM Do YYYY').toString()}</p></div>
                  </div>
                  <h3 className="my-8"><b>Title:</b> {workingSow.title}</h3>
                  <h3><b>Description of Work to be Performed:</b></h3>
                  <p className="mt-2">{workingSow.description}</p>
                </div>
              }
              <div className="border-cSage mb-4">
                  <div className="flex flex-col w-full mt-4">
                    <div className="w-full font-medium flex gap-2 bg-backgrounds text-text">
                      <div className="h-full" style={{ width: '15%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Category</p>
                      </div>
                      <div className="h-full" style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                      </div>
                      <div className="h-full" style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                      </div>
                      {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                      </div> */}
                      <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                      </div>
                      <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                      </div>
                    </div>
                  </div>
              </div>          
              {html}
              {workingSow.sowStatus === "Approved & Ready for Signatures" &&
              <div className="flex flex-col gap-2">
                <p className="font-semibold underline">ATTESTATION OF FUND USAGE</p>
                <p>I, {applicationDetails?.profileSnapshot.personalInfo?.firstName} {applicationDetails?.profileSnapshot.personalInfo?.lastName}, have legal authority to represent {applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName}, and attest that the support provided by Communitech
                under the Elevate IP program will not be used for any services that are already funded by another government program
                or grant. Any use of the Elevate IP program funds on services that are already funded by another government program
                or grant may lead to immediate termination from the Elevate IP program and/or the immediate return of such funding.</p>
              </div>
              }
            </div>
              <div className="inline-flex gap-4 ">
              {workingSow.sowStatus === "Awaiting Admin Approval" &&
                <Button
                  buttonText={"Approve SoW"}
                  buttonType='primary'
                  actionHandler={() => approveSoW(workingSow.sowId)}
                />
              }
              {workingSow.sowStatus === "Awaiting Expert Approval" &&
                <Button
                  buttonText={"Awaiting Expert Approval"}
                  buttonType='primary'
                  actionHandler={() => alert("Awaiting Expert Approval")}
                  disabled={true}
                />
              }
              {workingSow.sowStatus === "Approved & Ready for Signatures" &&
              <div className="mt-4">
                <Button
                  buttonText={"Export SoW PDF"}
                  buttonType='primary'
                  actionHandler={() => handleSowDownload(workingSow.title)}
                />
              </div>
              }
              {workingSow.sowStatus !== "Approved & Ready for Signatures" &&
                <Button
                  buttonText={"Request Changes"}
                  buttonType='secondary'
                  actionHandler={() => setModalHtml(sowFeedbackHTML)}
                />
              }
              </div>
          </div>
        );
        setIsModalOpen(true);
      }
    generateSowItemTableHtml()
  }
  } 

  const requestSowFormDefinition: FormDefinition = {
    firm: {
      label: "Select Service Provider Firm",
      frLabel: "Sélectionner Organisation/Admin",
      inputType: "dropdownSelect",
      validator: {
        required: {
          value: true,
          message: "Please select an option"
        }
      },
      additionalData: {
        selectionData:  memberDetailsAsync.value.providersArray
      }
    },
    tier: {
      label: "Select Service Tier",
      inputType: "dropdownSelect",
      validator: {
        required: {
          value: true,
          message: "Please select an option"
        }
      },
      additionalData: {
        selectionData: [
          {
            value: "2",
            text: "2",
          },
          {
            value: "3",
            text: "3",
          },
          {
            value: "2 and 3",
            text: "Both 2 and 3",
          }
        ]
      }
    },
    requestNotes: {
      label: "Notes for Service Provider",
      inputType: "textarea",
      validator: basic_text_validator
    }
  }
  const gcInviteString = applicationDetails?.growthCoach?.inviteDate ? `The request was sent to the Growth Coaches on ${moment(memberDetails.founderAdditionalData?.growthCoach?.inviteDate).format('MMM Do YYYY').toString()}` : ""

  let founderProfileGroupData = null
  if (applicationDetails) {
  founderProfileGroupData = convertFounderProfileDBStateToUIState(applicationDetails.profileSnapshot)
  if (founderProfileGroupData) {
      // Check if underrepresentedFounderGroups exists and includes specific values
      const groups = founderProfileGroupData.programingEvaluation.underrepresentedFounderGroups as string[];
      founderProfileGroupData.programingEvaluation.coPayEligible = false;  
      if (groups && (groups.includes("women") || groups && groups.includes("indigenous"))) {
        founderProfileGroupData.programingEvaluation.coPayEligible = true;  
      }
    }
  }
  const isUrl = applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL.includes("www.")
  const isHttpsUrl =  applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL.includes("https://")
  const urlHref = `https://${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}`
  const websiteHtml = isHttpsUrl ? <a className="underline font-normal mb-2" href={applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL} target="_blank">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</a> : isUrl ? <a className="underline font-normal mb-2" href={urlHref} target="_blank">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</a> : <p className={``}>{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</p>      
  let founderStatus = "n/a" 
  let statusStrings = ["Predates Update", "", "Action items not tracked on portal", ""]
  if (applicationDetails && applicationDetails.status) {
    if (applicationDetails.status === "growthCoachRecommendation") {
      statusStrings = returnFounderStatusStrings(applicationDetails.status, applicationDetails.growthCoach?.status)
    } else {
      statusStrings = returnFounderStatusStrings(applicationDetails.status)
    }
    founderStatus = applicationDetails.status
  }
  let applicationDate = null
  if (applicationDetails && applicationDetails?.createdAt) {
    applicationDate = applicationDetails.createdAt
  }
  let gcString = "N/A"
  if (applicationDetails?.growthCoach?.status) {
    gcString = applicationDetails?.growthCoach.status
  }
  let ipeString = "N/A"
  if (applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.assessorName) {
    ipeString = applicationDetails.expertAssessment.assessorName
  }
  let ownerString = "N/A"
  if (applicationDetails?.owner && applicationDetails?.owner.ownerName) {
    ownerString = applicationDetails.owner.ownerName
  }
  let cohort = 0
  if (applicationDetails?.cohort) {
    cohort = applicationDetails.cohort
  }
  const viewPdf = (pdfName: string) => {
    const pdfModalHtml = <div className="flex w-full min-w-full">
    <PdfDownloader docKey={pdfName}/>
  </div>
    setModalHtml(pdfModalHtml)
    setViewPdfName(pdfName)
    setIsModalOpen(true)
  }
  
  const simplifyDocString = (docType: string ) => {
    if (docType.includes("Pitch Deck")) {
      return `${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName} Pitch Deck`
    }
}

  let docHtml = <></>
  //OLD DOC RETREIVAL WILL NEED TO UPDATE FOR MORE DOCS ON APP I THINK
  if (applicationDetails && applicationDetails.profileSnapshot.documents) {
    const docs = applicationDetails.profileSnapshot.documents as {[key: string]: string;}
    if (docs && docs._id) {
      delete docs._id;
    }
    docHtml =
    <div className="w-full flex flex-col">
    {Object.keys(docs).map((key) => (
        <button key={key} className="flex mt-2 items-center hover:underline" onClick={() => viewPdf(docs[key])}>
          <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.1253 4.96448V4.85029C12.1253 4.85029 12.1253 4.80514 12.1022 4.80514L12.0341 4.73698L6.36849 0.0230173H6.34547C6.34547 0.0230173 6.32245 0.0230174 6.30032 0H2.71948C1.22341 0 0 1.22341 0 2.71948V13.2805C0 14.7766 1.22341 16 2.71948 16H9.51819C11.0143 16 12.2377 14.7766 12.2377 13.2805V5.07693L12.1253 4.96448ZM6.45967 1.31547L10.4256 4.60151H7.13954C6.75445 4.60151 6.45967 4.30673 6.45967 3.92164V1.31547ZM9.40578 14.9811H2.60707C1.61028 14.9811 0.794081 14.1649 0.794081 13.1681V2.60703C0.794081 1.61025 1.61028 0.794045 2.60707 0.794045H5.55318V3.92164C5.55318 4.80511 6.25607 5.508 7.13954 5.508H11.2188V13.1681C11.2188 14.1649 10.4026 14.9811 9.40578 14.9811Z" fill="#1A2E25"/></svg>
          {simplifyDocString(docs[key])}
        </button>
    ))}
    </div>
    
  }

  const modalClose = () => {
    setIsModalOpen(false)
    setViewingSow(false)
    setViewPdfName("")
  }

  //GC ASSESSMENT LOGIC

  const handleRejectApplication = async (reasonNoteForm: {reasonNote: string}) => {
    const reasonNote = reasonNoteForm.reasonNote
    if (applicationDetails) {
      showLoading();
      const res = await updateApplicationStatus(applicationDetails._id, reasonNote, "rejected", false, "membership");
      hideLoading();
      if (res.success) {
        showToast({
          toastType: "success",
          message: `Application has been Rejected`,
        });
        setIsModalOpen(false)
        setReloadOnOutletSave(!reloadOnOutletSave)
      } else {
        setIsModalOpen(false)
        showToast({
          toastType: "failure",
          message: `Unable to reject application at this time.  Please try again, and if the issue persists, contact support`,
        });
      }
    }
  }

  const primaryRejectButtonProp: ButtonProp = {
    buttonText: "Send",
    actionHandler: handleRejectApplication,
  }
  const memberName = applicationDetails?.profileSnapshot.personalInfo ? ` ${applicationDetails?.profileSnapshot.personalInfo?.firstName} ${applicationDetails?.profileSnapshot.personalInfo?.lastName},` : ","
  const companyName = applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName ? `${applicationDetails?.profileSnapshot.companyInfo.basicInfo.operatingName}` : "this company"
  const rejectionModalHtml = (
    <div className="flex flex-col rejectionModal">
    <h1 className="mb-6">Tier 1 Only</h1>
    <p className="mb-6 font-semibold">You are rejecting {companyName} from moving forward in the application process.</p>
    <p className=" mb-6">Hello{memberName}</p>
    <p className=" mb-6">Thank you for your application to the ElevateIP program. We regret to inform you that you are not eligible for Tier 2 or 3 funded services (IP Development and Implementation) at this time.</p>
    <p className="mb-2">Please provide an explanation for the rejection.</p>
    <Form 
        formDefinition={gcRejectFormDefinition}
        formData={null}
        primaryButtonProp={primaryRejectButtonProp}
      />
    <p className="mb-6 mt-6">However, you are eligible for our free Tier 1 IP Education services. Please visit your portal to make the most of those resources.</p>
    <p className=" mb-6">You’re welcome to respond with any questions or concerns.</p>
    <p className=" mb-6">Kindly,</p>
    <p className="">ElevateIP Team,</p>
    <p className="underline">www.elevateip.ca</p>
    <p className="underline">elevateip@communitech.ca</p>
  </div>
  )

  const handleReject = () => {
    setModalHtml(rejectionModalHtml)
    setIsModalOpen(true)
  }

  const confirmGcModalHtml = (
    <div className="w-full flex flex-col">
      <h1 className="mb-6">Growth Coach Review</h1>
      <p className="bodyLarger font-semibold mb-6">
        You are authorizing a Growth Coach review for {applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName}. By confirming, this applicant will be added to the list of companies to review.
      </p>
      <Button 
        buttonText="Confirm"
        actionHandler={() => handleGrowthCoach()}
      />
    </div>
  )

  const handleGrowthCoachModal = () => {
    setModalHtml(confirmGcModalHtml)
    setIsModalOpen(true)
  }
  
  //SCREENED LOGIC
  const handleGrowthCoach = async () => {
    if (applicationDetails) {
    showLoading();
    const res = await growthCoachByapplication(applicationDetails._id)
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Status Updated",
      });

    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }}

  //IPE UPDATE STATUS
  const handleIpeSatusUpdate = async () => {
    showLoading();
    const res = await setIpeStatus(memberId)
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "IP Experts Notified",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }

  const ipeRecReject = async () => {
    showLoading();
    const res = await ipeReject(applicationDetails?._id || "")
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Flagged for rejection",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }

  const requestSow = async () => {
    showLoading();
    const res = await intiateSowRequest(applicationDetails?._id || "")
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Confirmation of Service Provider Requested!",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
      setIsModalOpen(false)
    } else {
      showToast({
        toastType: "failure",
        message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
      });
    }
  }


  const createSowRequest = async (updatedFormData?: FormData) => {
    const sowRequestData = updatedFormData as any
    
    showLoading();
    const res = await createNewProject(memberId, sowRequestData.firm, sowRequestData.tier, sowRequestData.requestNotes) 
    hideLoading();
    if (res.success) {
      showToast({
        toastType: "success",
        message: "Statement of Work Requested!",
      });
      setIsModalOpen(false)
      setReloadOnOutletSave(!reloadOnOutletSave)
  }
}

  const primarySowRequestButtonProp: ButtonProp = {
    buttonText: "Create Sow Request",
    actionHandler: createSowRequest,
    buttonType: "primaryFull"
  }

  const openSowModal = () => {
    setModalHtml( 
    <div className="mt-10 flex flex-col justify-center items-center w-full">
      <h1 className="mb-6">SoW Request Details</h1>
        <Form
          formDefinition={requestSowFormDefinition}
          formData={null}
          primaryButtonProp={primarySowRequestButtonProp}
        />
    </div>
    )
  }

  const handleViewRec = () => {
    setModalHtml(ipeRecModalHtml)
    setIsModalOpen(true)
  }
  
  const sowEligible = applicationDetails?.expertAssessment?.ipAssessmentObj?.t2ServiceRec === "approve" || applicationDetails?.expertAssessment?.ipAssessmentObj?.t3ServiceRec === "approve" ? true : false 

  const ipeRecModalHtml = (
    <div className="flex flex-col viewRecModal">
       {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipRejectionObj &&
        <div>
          <div className="flex w-full flex-col gap-4">
            <h4 className="">Reasoning:</h4>
            <div className="w-full inline-flex flex-wrap">
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.hardCrit}
                    disabled={true}
                  />
                  <span className="ml-2">Hard Criteria</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.notTech}
                    disabled={true}
                  />
                  <span className="ml-2">Not Technology</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.economicBenefit}
                    disabled={true}
                  />
                  <span className="ml-2">Economic Benefit</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.revScore}
                    disabled={true}
                  />
                  <span className="ml-2">Revenue Source</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.marketReadiness}
                    disabled={true}
                  />
                  <span className="ml-2">Market Readiness</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.ipOwnership}
                    disabled={true}
                  />
                  <span className="ml-2">IP Ownership</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.commercialization}
                    disabled={true}
                  />
                  <span className="ml-2">Commercialization</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.jobCreation}
                    disabled={true}
                  />
                  <span className="ml-2">Job Creation</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={applicationDetails.expertAssessment.ipRejectionObj.teamFit}
                    disabled={true}
                  />
                  <span className="ml-2">Team Fit</span>
                </label>
              </div>
            </div>

            <Button 
              buttonText="Tier 1 Only"
              actionHandler={() => ipeRecReject()}
              buttonType="secondaryFull"
            />
        
          </div>
        </div>
      }
      {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipAssessmentObj && 
        <div className="overflow-y-auto flex flex-col w-full">
          <p className="font-semibold bodyLarger mb-4">Tier 1 - Education and Awareness</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t1Rec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <Form 
            readOnly={true}
            disabled={true}
            formDefinition={t1AssessmentForm}
            formData= {{
              t1Rec: applicationDetails.expertAssessment.ipAssessmentObj.t1Rec || "",
              t1Score: applicationDetails.expertAssessment.ipAssessmentObj.t1Score || "",
              t1Notes: applicationDetails.expertAssessment.ipAssessmentObj.t1Notes || "",
            }}
          />
          }
          <p className="font-semibold bodyLarger mb-4">Tier 2 - Coaching</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t2CoachRec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <Form 
            readOnly={true}
            disabled={true}
            formDefinition={t2CoachAssessmentForm}
            formData= {{
              t2CoachRec: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachRec || "",
              t2CoachScore: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachScore || "",
              t2CoachNotes: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachNotes || "",
            }}
          />
          }
          <p className="font-semibold bodyLarger mb-4">Tier 2 - Service</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceRec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <div className="w-full flex flex-col gap-2">
            <Form
              readOnly={true}
              disabled={true} 
              formDefinition={t2ServiceAssessmentForm}
              formData= {{
                t2ServiceRec: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceRec || "",
                t2ServiceScore: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceScore || "",
                t2ServiceNotes: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceNotes || "",
              }}
              />
              {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray && applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray.length > 0 &&
              <div className="flex flex-col gap-2 mb-6">
                <p className="bodyLarger">Recommended Tier 2 Services</p>
                <ul className="">
                  {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              }
          </div>
          }
          <p className="font-semibold bodyLarger mb-4">Tier 3 - Service</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceRec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <div className="w-full flex flex-col gap-2">
            <Form 
              readOnly={true}
              disabled={true}
              formDefinition={t3serviceAssessmentForm}
              formData= {{
                t3ServiceRec: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceRec || "",
                t3ServiceScore: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceScore || "",
                t3ServiceNotes: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceNotes || "",
              }}
            />
            {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray && applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray.length > 0 &&
              <div className="flex flex-col gap-2 mb-6">
              <p className="bodyLarger">Recommended Tier 3 Services</p>
              <ul className="">
                {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            }
            {
              applicationDetails.expertAssessment.ipAssessmentObj.successStory && applicationDetails.expertAssessment.ipAssessmentObj.successStoryNotes &&
              <div className="w-full flex flex-col gap-2 mb-6">
                <p className="font-semibold">Success Story Notes</p>
                <p>{applicationDetails.expertAssessment.ipAssessmentObj.successStoryNotes}</p>
              </div>
            }
          </div>
          }
          <div>
            {sowEligible &&
            <Button 
              buttonText="Authorize SoW"
              actionHandler={() => requestSow()}
            />
            }
          </div>
          <Button 
            buttonText="Flag for Rejection"
            buttonType="secondary"
            actionHandler={() => flagForRejection()}
          />
        </div>
      }
    </div>
  )

  const bnNumLink = document.querySelector('a[href="https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html"]');
  if (bnNumLink) {
    bnNumLink.classList.add('underline');
  }
  const nextStepString = () => {
    if (!hardCrit) {
      if (nextStep === "No") {
        return <div>
          <p className="mb-2">We would like to stress that this is not a testament to your work, but simply a reflection of the interest in the program.</p>
          <p className="mb-2">We appreciate your understanding and wish you success in securing the support your company needs.</p>
          <p>Thank you,</p>
          <p className="mb-2">The ElevateIP Team</p>
          <p className="">www.elevate-ip.ca</p>
        </div>
      } else if (nextStep === "Later") {
        return <div>
        <p className="mb-2">While we understand that this is disappointing, we would like to encourage you to reconnect with ElevateIP as your path to commercialization progresses as opportunities for support may arise in the future.</p>
        <p className="mb-2">We appreciate your understanding and wish you success in securing the support your company needs.</p>
        <p className="mb-2">Thank you,</p>
        <p>The ElevateIP Team</p>
        <p className="">www.elevate-ip.ca</p>
      </div>
      }
    }
  }
  const emailPreview = () => {
    if (hardCrit) {
      return <div className="flex flex-col">
              <p className="mb-2">Thank you again for applying to ElevateIP.</p>
              <p className="mb-2">After a careful review of your application, your company did not meet the criteria required to be eligible to receive funding from ElevateIP. ElevateIP recipients must have less than 500 full time employees, be a CCPC (Canadian Controlled Private Corporation), and the IP needs to be owned by the corporation.</p>
              <p className="mb-2">We appreciate your interest in ElevateIP, and wish you the best of luck in securing the support your company needs.</p>
              <p className="mb-2">The ElevateIP Team</p>
              <p className="">www.elevate-ip.ca</p>
              <p className="mb-2">The ElevateIP Team</p>
            </div>
    } else {
      const reasonArray = []
      if (notTech) {
        reasonArray.push("The potential use or impact of your technology does not match the level of innovation of comparable applications.")
      }
      if (economicBenefit) {
        reasonArray.push("The anticipated overall economic and/or social benefit of your project scored lower than that of other applications.")
      }
      if (revScore) {
        reasonArray.push("The primary source of your revenue does not derive from your technology being developed or the time to commercialize the technology is longer compared to other applications.")
      }
      if (marketReadiness) {
        reasonArray.push("Given the early stage of your company, the path to production, or the status of your IP, the projected economic benefit does not match that of other applications.")
      }
      if (ipOwnership) {
        reasonArray.push("The IP in question does not belong to the organization, the ownership structure was unclear at the time of assessment, or the potential for the IP to be granted is lower than that of comparable applications.")
      }
      if (commercialization) {
        reasonArray.push("The IP to be secured is in a very early stage or the path to commercialization does not demonstrate the same capacity for growth and expansion compared to other applications.")
      }
      if (jobCreation) {
        reasonArray.push("Your company structure or projected impact on the labour market through this IP scores lower than other applications.")
      }
      if (teamFit) {
        reasonArray.push("Priorities or role distribution within your team are not as streamlined as team structures of comparable applications.")
      }
      return <div className="flex flex-col">
                <p className="mb-2 mt-2">Thank you again for applying to ElevateIP.</p>
                <p className="mb-2">After a careful review of your application, our assessment committee determined that your company's current status does not match the criteria sought for participation in ElevateIP as well as other applications.</p>
                <p className="mb-2">As the program is very competitive, we had to make the difficult call to decide against moving forward with your application. While this was not an easy decision, it was based on an assessment of various factors including, but not limited to:</p>
                {reasonArray.map((str, index) => (
                <p className="mb-2" key={index}>{str}</p>
              ))}
            </div>
    }
  }

  const rejectionProgCheck = () => {
    if (applicationDetails?.rejectionReasons) {
        setNextStep(applicationDetails.rejectionReasons.nextStep)
        setHardCrit(applicationDetails.rejectionReasons.hardCrit)
        setNotTech(applicationDetails.rejectionReasons.notTech)
        setEconomicBenefit(applicationDetails.rejectionReasons.economicBenefit)
        setRevScore(applicationDetails.rejectionReasons.revScore)
        setMarketReadiness(applicationDetails.rejectionReasons.marketReadiness)
        setIpOwnership(applicationDetails.rejectionReasons.ipOwnership)
        setHardCrit(applicationDetails.rejectionReasons.hardCrit)
        setCommercialization(applicationDetails.rejectionReasons.commercialization)
        setJobCreation(applicationDetails.rejectionReasons.jobCreation)
        setTeamFit(applicationDetails.rejectionReasons.teamFit)
      } else if (applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipRejectionObj) {
        setHardCrit(applicationDetails.expertAssessment.ipRejectionObj.hardCrit)
        setNotTech(applicationDetails.expertAssessment.ipRejectionObj.notTech)
        setEconomicBenefit(applicationDetails.expertAssessment.ipRejectionObj.economicBenefit)
        setRevScore(applicationDetails.expertAssessment.ipRejectionObj.revScore)
        setMarketReadiness(applicationDetails.expertAssessment.ipRejectionObj.marketReadiness)
        setIpOwnership(applicationDetails.expertAssessment.ipRejectionObj.ipOwnership)
        setHardCrit(applicationDetails.expertAssessment.ipRejectionObj.hardCrit)
        setCommercialization(applicationDetails.expertAssessment.ipRejectionObj.commercialization)
        setJobCreation(applicationDetails.expertAssessment.ipRejectionObj.jobCreation)
        setTeamFit(applicationDetails.expertAssessment.ipRejectionObj.teamFit)
      }
      setIsRejectionModalOpen(true)
    }

  async function saveRejectionProg () {
    showLoading();
    const response = await updatedRejectionProg(nextStep, hardCrit, notTech, economicBenefit, revScore, marketReadiness, ipOwnership, commercialization, jobCreation, teamFit, memberId);
    hideLoading();  
    if (response.success) {
      showToast({
        toastType: "success",
        message: "Rejection Progress Saved",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
      setIsRejectionModalOpen(false)
    }
  }

  async function sendRejectionEmail () {
    showLoading();
    const response = await rejectionEmailTrigger(nextStep, hardCrit, notTech, economicBenefit, revScore, marketReadiness, ipOwnership, commercialization, jobCreation, teamFit, memberId);
    hideLoading();  
    if (response.success) {
      showToast({
        toastType: "success",
        message: "Rejection Email Sent",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
      setIsRejectionModalOpen(false)    }
  }
  
  const handleSpfChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setSpf(event.target.value)
  }

  const submitServiceProvider = async function (appId: string) {
    showLoading();
    const response = await submitSpf(appId, spf);
    hideLoading();  
    if (response.success) {
      showToast({
        toastType: "success",
        message: "Service Provider Selected",
      });
      setReloadOnOutletSave(!reloadOnOutletSave)
      setSelectSpf(false)    
    }
  }

  const getNeedHelpFormDef = (founderProfile: T.StartupFounderProfile, regionalFirmOptions: {value: string, text: string}[]) => {
    const regionalFirmSelectionData = () => {
      const array: {value: string, text: string}[] = []
      regionalFirmOptions.forEach((item) => (
        array.push(
          {value: item.value, 
          text: item.text, 
          }
        )
      ))
      array.push({value: "Other", text: "Other"})
      return array
    }
    
    let modifiedForm = { ...needHelpWithDefinition };
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "topics";
      const newValue: FieldDefinition = {
          label: "Please select the topics that you'd like to discuss with our IP Advisor:",
          frLabel: "",
          inputType: "multiSelect",
          validator: selection_validator,
          conditionalRenderDefinition: {
            fieldKey: "businessGoal",
            renderWhenTrue: true, 
          },
          additionalData: {
            selectionData: [
              {
                value: "Patents",
                text: "Patents",
                frText: "",
              },
              {
                value: "Industrial Designs/ Design Patents",
                text: "Industrial Designs/ Design Patents",
                frText: "",
              },
              {
                value: "Trademarks",
                text: "Trademarks",
                frText: "",
              },
              {
                value: "Trade Secrets",
                text: "Trade Secrets",
                frText: "",
              },
              {
                value: "Copyright",
                text: "Copyright",
                frText: "",
              },
              {
                value: "Open Source Asset Use",
                text: "Open Source Asset Use",
                frText: "",
              },
              {
                value: "IP Strategy",
                text: "IP Strategy",
                frText: "",
              },
              {
                value: "IP Ownership",
                text: "IP Ownership",
                frText: "",
              },
              {
                value: "Freedom to Operate",
                text: "Freedom to Operate",
                frText: "",
              },
            ]
          },
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "businessGoal") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "specificDiscussion";
      const newValue: FieldDefinition = {
        label: "Without specifically referencing IP sensitive information, please provide a general overview of what you' like to discuss with our IP Advisor",
        frLabel: "",
        inputType: "textarea",
        conditionalRenderDefinition: {
          fieldKey: "businessGoal",
          renderWhenTrue: true, 
        },
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "topics") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Other")) {
      const newKey = "activitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Other")) {
      const newKey = "patentActivitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator  
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.searchCompleted) {
      const newKey = "searchCompleted";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "yes",
              text: "Yes",
              frText: "Oui",
            },
            {
              value: "no",
              text: "No",
              frText: "Non",
            },
            {
              value: "n/a",
              text: "N/A",
              frText: "N/A",
            }
          ]
        },     
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Patent Filing")) {
      const newKey = "patentsReadyOptions";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:",
        frLabel: "",
        inputType: "multiSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              frText: "",
            },
            {
              value: "I have a granted patent in the same patent family.",
              text: "I have a granted patent in the same patent family.",
              frText: "",
            },
            {
              value: "I have received a favorable written opinion from my PCT application.",
              text: "I have received a favorable written opinion from my PCT application.",
              frText: "",
            },
            {
              value: "None of the Above",
              text: "None of the Above",
              frText: "",
            }
          ]
        },
      };
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm) {
        const newKey = "firmId";
        const newValue: FieldDefinition = {
          label: `Please select the firm (select "Other" if your current firm is not listed)`,
          frLabel: "",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: regionalFirmSelectionData()
          },
          };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "workingWithFirm") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
      
      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.exclusiveRights) {
        const newKey = "exclusiveRights";
        const newValue: FieldDefinition = {
          label: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
          frLabel: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "yes",
                text: "Yes",
                frText: "Oui",
              },
              {
                value: "no",
                text: "No",
                frText: "Non",
              },
              {
                value: "n/a",
                text: "N/A",
                frText: "N/A",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
  
      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Trademark Filing")) {
        const newKey = "searchCompleted";
        const newValue: FieldDefinition = {
          label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "yes",
                text: "Yes",
                frText: "Oui",
              },
              {
                value: "no",
                text: "No",
                frText: "Non",
              },
              {
                value: "n/a",
                text: "N/A",
                frText: "N/A",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
  
      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm && founderProfile.needHelpWith.firmId === "Other" && founderProfile.needHelpWith.firmOther) {
        const newKey = "firmOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator    
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "firmId") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport) {
        const newKey = "supportOrg";
        const newValue: FieldDefinition = {
          label: `Please select which organization:`,
          frLabel: "Veuillez préciser quelle organisation:",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "Intellectual Property Ontario (IPON)",
                text: "Intellectual Property Ontario (IPON)",
                frText: "",
              },
              {
                value: "IP Assist",
                text: "IP Assist",
                frText: "",
              },
              {
                value: "Other",
                text: "Other",
                frText: "",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "govtSupport") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport && founderProfile.needHelpWith.supportOrg === "Other" && founderProfile.needHelpWith.supportOrgOther) {
        const newKey = "supportOrgOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator        
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "supportOrg") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

    return modifiedForm
  }

  return (
    <div className="resourcesCont !pt-0 !gap-0">
        <header className="dashboardHeader ">
          <div className='headerSect'>
            <button 
              className='flex bodyLarger buttonSizer'
              onClick={logout}
            >
              <svg className='mr-2' xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path d="M2.60117 12.6826L2.62197 12.7105L2.62194 12.7105C3.31089 13.6256 4.21794 14.3783 5.26877 14.8979C6.29021 15.403 7.45043 15.6879 8.68188 15.6879C10.7469 15.6879 12.616 14.8831 13.9688 13.5821C15.3215 12.2811 16.1575 10.4843 16.1575 8.50003C16.1575 6.51571 15.3214 4.71894 13.9688 3.41797C12.616 2.11692 10.7469 1.31213 8.68188 1.31213C7.45417 1.31213 6.29756 1.59507 5.27926 2.09609C4.22058 2.61748 3.30739 3.37501 2.61589 4.29603C2.47204 4.48838 2.19528 4.53117 1.99654 4.39366C1.7966 4.25534 1.75032 3.98628 1.89506 3.79278L1.89513 3.7927C2.66968 2.76184 3.69136 1.91429 4.87674 1.33069C6.02011 0.767551 7.31393 0.45 8.68198 0.45C10.9922 0.45 13.0844 1.3506 14.5986 2.80692L14.5986 2.80692C16.1128 4.26383 17.05 6.27677 17.05 8.5C17.05 10.7236 16.1128 12.7367 14.5986 14.1931L14.5986 14.1931C13.0838 15.6494 10.9917 16.55 8.68198 16.55C7.30756 16.55 6.00899 16.2298 4.86243 15.6631C3.6733 15.0754 2.65003 14.2223 1.8771 13.1858L1.87704 13.1857C1.73295 12.9917 1.77975 12.7217 1.98023 12.5834C2.17965 12.4458 2.45741 12.4898 2.60117 12.6826ZM1.08524 8.18019L1.11158 8.15552L3.75033 5.61765C3.9241 5.44997 4.20534 5.45004 4.37955 5.61756C4.55497 5.78575 4.55487 6.05954 4.37958 6.22813L4.34492 6.19209L4.37957 6.22813L2.47601 8.05837H11.5025C11.7472 8.05837 11.9485 8.24931 11.9485 8.48921C11.9485 8.72918 11.7471 8.92005 11.5025 8.92005H2.47599L4.37952 10.7508C4.55495 10.919 4.55488 11.1927 4.37964 11.3613C4.20586 11.529 3.9246 11.5289 3.75039 11.3614L1.08524 8.79814C1.08516 8.79807 1.08508 8.79799 1.085 8.79791C1.06218 8.7765 1.04208 8.75257 1.02468 8.72795L1.0243 8.72822L1.02255 8.72485L1.01816 8.71829L1.0134 8.71117L1.01314 8.71134L1.01082 8.70687C0.972479 8.64331 0.950001 8.56882 0.950001 8.48917C0.950001 8.40969 0.972374 8.33537 1.01055 8.2719L1.01031 8.27177L1.0134 8.26716L1.01816 8.26005L1.01717 8.25938L1.02099 8.25572L1.02438 8.2508C1.04224 8.22498 1.06258 8.20142 1.08524 8.18019Z" fill="#1A2E25" stroke="#1A2E25" strokeWidth="0.1"/></svg>
              <span className="relative">Logout</span>
            </button>
          </div>
        </header>
      <h2 className="">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName ? applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName : memberDetails.username}</h2>
      {selectSpf &&      
      <div className='largeModal'>
        <div className='largeModalInner !h-fit !w-fit'>
          <div className='flex justify-end w-full'>
            <button onClick={() => setSelectSpf(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </div>
          <div className="flex flex-col gap-4">
            <div className="w-full flex flex-col">
              <p className="font-semibold bodyLarger">Please select the Service Provider the company requested.</p>  
            </div>
            <select className={`${inputClasses}`} onChange={handleSpfChange} id="spfSelect" name="spfSelect" value={spf} style={{wordWrap: "break-word"}}>
              <option disabled value="">Please make a selection</option>
              {memberDetailsAsync.value.providersArray.map((firm) => (
                <option key={firm.value} value={firm.value}>
                {firm.text}
                </option>
              ))}
            </select>
            {applicationDetails &&
            <Button
              buttonText="Select Service Provider"
              disabled={spf === ""}
              actionHandler={() => submitServiceProvider(applicationDetails._id)}
            />
            }
          </div>
        </div>
      </div>
      }
      {isRejectionModalOpen &&
      <div className='largeModal'>
        <div className='largeModalInner'>
          <div className='flex justify-end w-full'>
            <button onClick={() => setIsRejectionModalOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </div>
          <div className="flex flex-col w-full">
            <div className="flex w-full flex-col">
              <h4 className="w-full">Next Steps:</h4>
              <div className="flex w-full my-2">
                <div className="flex bodyLarger">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={nextStep === "No"}
                      onChange={() => handleNextStepChange("No")}
                    />
                    <span className="ml-2">No</span>
                  </label>
                </div>
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={nextStep === "Later"}
                    onChange={() => handleNextStepChange("Later")}
                  />
                  <span className="ml-2">Later</span>
                </label>
                </div>
            </div>
            <div className="flex w-full flex-col">
              <h4 className="">Reasoning:</h4>
                <div className="w-full inline-flex flex-wrap">
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={hardCrit}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("hardCrit")}
                      />
                      <span className="ml-2">Hard Criteria</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={notTech}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("notTech")}
                      />
                      <span className="ml-2">Not Technology</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={economicBenefit}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("economicBenefit")}
                      />
                      <span className="ml-2">Economic Benefit</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={revScore}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("revScore")}
                      />
                      <span className="ml-2">Revenue Source</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={marketReadiness}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("marketReadiness")}
                      />
                      <span className="ml-2">Market Readiness</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={ipOwnership}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("ipOwnership")}
                      />
                      <span className="ml-2">IP Ownership</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={commercialization}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("commercialization")}
                      />
                      <span className="ml-2">Commercialization</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={jobCreation}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("jobCreation")}
                      />
                      <span className="ml-2">Job Creation</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={teamFit}
                        disabled={nextStep === ""}
                        onChange={() => changeCriteria("teamFit")}
                      />
                      <span className="ml-2">Team Fit</span>
                    </label>
                  </div>
                </div>
            </div>
            <h4>Email Preview:</h4>
            {nextStep !== "" &&
              <div className="flex flex-col w-full bodyLarger">
                {emailPreview()}
                {nextStepString()}
              </div>
            }
            <div className="w-full my-4 flex gap-4">
              <Button
                buttonText={"Save Rejection Progress"}
                actionHandler={() => saveRejectionProg()}
                buttonType="primaryFull"
                disabled={nextStep === ""}
              />
              <Button
                buttonText={"Send Rejection Email Now"}
                actionHandler={() => sendRejectionEmail()}
                buttonType="primaryFull"
                disabled={!hardCrit && !notTech && !economicBenefit && !revScore && !marketReadiness && !ipOwnership && !commercialization && !jobCreation && !teamFit}
              />
            </div>
          </div>

        </div>
      </div>
      }
      <div className="w-full flex justify-between switchFlex mt-8">
        <div className="memDetailsCont1">
          <div>
            <div className="flex flex-col mb-4">
            {applicationDetails?.profileSnapshot.companyInfo?.basicInfo ?
            <div>
              {websiteHtml}
              <p className="">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.description}</p>
            </div>
            :
            <p>Startup has not completed Company Information</p>
            }
            </div>
            { 
            applicationDetails?.profileSnapshot.personalInfo ?
            <div className="flex flex-col gap-2">
              <p className="bodyLarger font-semibold">{`${applicationDetails?.profileSnapshot.personalInfo?.firstName} ${applicationDetails?.profileSnapshot.personalInfo?.lastName} `}<span className="font-normal">{`(${applicationDetails?.profileSnapshot.personalInfo?.pronouns})`}</span></p>
              <p className="">{applicationDetails?.profileSnapshot.personalInfo.title}</p>
              <p className=" flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M0.976621 0.000509719C0.700221 0.00156869 0.459824 0.129712 0.282949 0.304455C0.108208 0.54168 -0.00510934 0.777847 0.000177378 1.00873C0.139969 5.09143 1.42987 8.35727 3.76188 10.591C6.09707 12.8277 9.45311 14.0076 13.6491 14C13.9192 13.9629 14.1808 13.8464 14.3481 13.6854C14.525 13.5107 14.6616 13.2745 14.6626 12.997C14.6701 12.0248 14.6775 11.0505 14.6838 10.0782C14.6764 9.80605 14.5419 9.58048 14.364 9.41103C14.1861 9.24159 13.9478 9.11558 13.6703 9.11769C12.7564 9.12087 11.5342 8.80209 10.5493 8.55746C10.437 8.52887 10.312 8.56275 10.2294 8.64324L8.50107 10.3186C6.39782 9.06792 5.4795 8.17622 4.19497 6.13536L5.91272 4.47056C5.99956 4.38583 6.03556 4.25134 6.0038 4.13484C5.74115 3.15099 5.28895 1.84097 5.36307 0.869812C5.3493 0.60611 5.12267 0.369932 4.95217 0.240747C4.77213 0.10625 4.53384 -0.00706801 4.25321 0.000344244H0.977615L0.976621 0.000509719ZM0.976621 0.683581H4.26822C4.34447 0.680404 4.44719 0.720648 4.54039 0.790544C4.62299 0.851967 4.67488 0.928218 4.68971 0.950458C4.64205 2.05609 5.03706 3.23164 5.287 4.12005L3.51522 5.84311C3.40296 5.95008 3.37966 6.13857 3.46227 6.2699C4.91422 8.62415 5.9563 9.63334 8.3762 11.045C8.50329 11.1202 8.68015 11.1001 8.78711 10.9974L10.5695 9.26374C11.5152 9.50202 12.6664 9.80702 13.6745 9.80279C13.7285 9.80279 13.8217 9.83668 13.8938 9.90446C13.9647 9.97224 13.9997 10.0612 14.0007 10.0961L13.9795 12.9938C13.9795 13.0372 13.9456 13.1294 13.8726 13.2014C13.7995 13.2734 13.6936 13.3147 13.6269 13.3189C9.57074 13.3221 6.41795 12.1868 4.2363 10.0962C2.05044 8.00141 0.814572 4.92715 0.683353 0.967256C0.68653 0.888888 0.740542 0.838053 0.769136 0.791454C0.825265 0.727911 0.912105 0.710966 0.976709 0.684492L0.976621 0.683581Z" fill="#1A2E25"/></svg>
                {applicationDetails?.profileSnapshot.personalInfo.phoneNumber}
              </p>
              <p className=" flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="21" height="14" viewBox="0 0 21 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.643217 0.98439C2.48353 2.62505 4.23794 4.12706 5.56312 5.24541C6.28 5.84952 6.87069 6.34091 7.28344 6.68229C7.43758 6.81057 7.56688 6.91712 7.66826 6.99987C4.25759 9.80223 3.87174 10.1457 0.780714 12.8954C0.735196 12.9357 0.688645 12.9761 0.64313 13.0174C0.582096 10.1012 0.552096 8.55066 0.552096 6.99985C0.552096 5.44904 0.582183 3.89957 0.643217 0.98439ZM1.09424 13.3546C5.59016 13.4167 7.9508 13.4477 10.3104 13.4477C12.6741 13.4477 15.038 13.4167 19.5482 13.3546C16.3672 10.4095 16.03 10.1115 12.5262 7.35765L11.2186 8.5028C10.6983 8.95798 9.92241 8.95798 9.40206 8.5028L8.09759 7.36178C4.62283 10.2168 4.2587 10.5407 1.1502 13.3047C1.13158 13.3212 1.11286 13.338 1.09424 13.3546ZM8.27766 6.78573C8.28076 6.7878 8.28283 6.78987 8.2849 6.79194L9.76521 8.08709C10.0776 8.36018 10.5431 8.36018 10.8555 8.08709L12.3359 6.79194C12.3379 6.78987 12.341 6.7878 12.3441 6.78573L12.3772 6.75884C12.399 6.74022 12.4321 6.71332 12.4765 6.67712C12.5645 6.6047 12.6969 6.49712 12.8696 6.35435C13.2162 6.06781 13.7283 5.6416 14.3914 5.08195C15.6172 4.04643 17.3603 2.5537 19.5244 0.645087C15.0296 0.583018 12.67 0.551985 10.3104 0.551985C7.94975 0.551985 5.58913 0.58302 1.09136 0.645087C2.89858 2.25368 4.61591 3.72473 5.9191 4.82322C6.63392 5.4263 7.22358 5.91665 7.6353 6.257C7.84012 6.42665 8.0015 6.55906 8.11116 6.64907C8.16495 6.69355 8.20736 6.72872 8.23529 6.75148L8.27766 6.78573ZM19.9775 0.980417C17.77 2.9304 15.9927 4.452 14.7472 5.50414C14.0821 6.06483 13.569 6.49207 13.2214 6.77964C13.119 6.86343 13.0311 6.93584 12.9586 6.99584C16.4106 9.71029 16.7634 10.0249 19.9786 13.001C20.0386 10.0951 20.0686 8.54771 20.0686 7.00008C20.0686 5.44941 20.0385 3.89745 19.9775 0.980417ZM0.375242 0.103188C10.3093 -0.034396 10.3114 -0.034396 20.2452 0.103188C20.3932 0.105257 20.5142 0.225256 20.5173 0.373176C20.6549 6.99801 20.6549 7.00199 20.5173 13.6268C20.5142 13.7748 20.3932 13.8947 20.2452 13.8968C10.3112 14.0344 10.3091 14.0344 0.375242 13.8968C0.227314 13.8947 0.106286 13.7747 0.103188 13.6268C-0.034396 7.00199 -0.034396 6.99801 0.103188 0.373176C0.106291 0.225248 0.227324 0.105254 0.375242 0.103188Z" fill="#1A2E25"/></svg>
                {memberDetails.email}
              </p>
            </div>
            :
            <p>Startup has not completed Personal Information</p>
            }
          </div>
          <div className="w-full overflow-y-auto mr-2">
          <Accordion
              allowZeroExpanded={true}
              className="w-full mb-4"
              >    
              <AccordionItem
                  uuid={0}
                  className=""
                  key={`0`}
                  onClick={() => setChildClickedAccordionItemIndex(0)}
                  >
                  <AccordionItemHeading>
                    <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                      <p className="font-semibold bodyLarger">Scoring</p>
                      <AccordionItemState>
                      {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                  {applicationDetails && applicationDetails.applicationScore &&          
                  <div>
                    {applicationDetails?.profileSnapshot.ipPreScore && applicationDetails?.profileSnapshot.applicationScore &&
                      <h4 className="font-semibold mt-4">Total Score: {applicationDetails?.profileSnapshot.ipPreScore?.totalScore + applicationDetails?.profileSnapshot.applicationScore?.totalScore}</h4>
                    }
                    {applicationDetails && applicationDetails.profileSnapshot.ipPreScore === undefined && applicationDetails?.profileSnapshot.applicationScore &&
                      <h4 className="font-semibold mt-4">Total Score: {applicationDetails?.profileSnapshot.applicationScore?.totalScore}</h4>
                    }
                    <div className="flex flew-wrap w-full">
                      <div className="flex flex-col text-text w-1/2 mb-3">
                        <p className="bodyLarger">Persona Score: {applicationDetails.applicationScore?.totalScore}</p>
                        <ul className="small">
                          <li>Classification: {applicationDetails.applicationScore?.classification}</li>
                          <li>Age Score: {applicationDetails.applicationScore?.age}</li>
                          <li>Revenue Score: {applicationDetails.applicationScore?.revenue}</li>
                          <li>Employee Score: {applicationDetails.applicationScore?.fte}</li>
                        </ul>
                      </div> 
                      {applicationDetails?.profileSnapshot.ipPreScore &&            
                      <div className="flex flex-col text-text w-1/2 mb-3">
                        <p className="bodyLarger">IP PreScore: {applicationDetails.ipPreScore?.totalScore}</p>
                        <ul className="small">
                          <li>IP Readiness - Patents: {applicationDetails.ipPreScore?.ipReadinessPatents}</li>
                          <li>IP Readiness - General: {applicationDetails.ipPreScore?.ipReadinessGeneral}</li>
                        </ul>
                      </div>
                      }
                    </div>
                  </div>
                  }
                  </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem
                  uuid={1}
                  className=""
                  key={`1`}
                  onClick={() => setChildClickedAccordionItemIndex(1)}
                  >
                  <AccordionItemHeading>
                      <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                        <p className="font-semibold bodyLarger">Program Application</p>
                        <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  <AccordionItemPanel>
                    {applicationDetails ?
                    <div className="mt-4">                  
                    <div className="flex flex-col applicationFormWidth">
                      <h4 className="mb-6">Personal Info</h4>
                      <Form
                        formDefinition={profileFormPersonalInfoDefinition}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.personalInfo ? applicationDetails?.profileSnapshot.personalInfo : null}
                        readOnly
                        disabled
                      />
                      <h4 className="mb-6">Address</h4>
                      <Form
                        formDefinition={addressFormDefinition}
                        formData={applicationDetails?.profileSnapshot.companyInfo?.mailingAddress || null}
                        readOnly
                        disabled
                      />
                      <h4 className="mb-6 mt-8">Company Info</h4>
                      {applicationDetails &&
                        <Form
                        formDefinition={getModifiedCompanyInfoFormDef(applicationDetails.profileSnapshot)}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.companyInfo ? companyInfoToForm(applicationDetails?.profileSnapshot.companyInfo) : null}
                        readOnly
                        disabled
                      />
                      }
                      <h4 className="mb-6 mt-8">Need Help With</h4>
                      {applicationDetails &&
                      <Form
                        formDefinition={getNeedHelpFormDef(applicationDetails.profileSnapshot, memberDetailsAsync.value.providersArray)}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.needHelpWith ? applicationDetails?.profileSnapshot.needHelpWith : null}
                        readOnly
                        disabled
                      />
                      }
                      <h4 className="mb-6 mt-8">Community, Culture & Climate</h4>
                      <Form
                        formDefinition={profileFormAdminProgramingEvaluationDefinition}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.programingEvaluation ? applicationDetails?.profileSnapshot.programingEvaluation : null}
                        readOnly
                        disabled
                      />
                    </div>
                    </div>
                    :
                    <p className="mt-4">No application has been submitted</p>
                    }
                  </AccordionItemPanel>
                </AccordionItem>
                {applicationDetails && applicationDetails.ddObj &&
                <AccordionItem
                  uuid={2}
                  className=""
                  key={`2`}
                  onClick={() => setChildClickedAccordionItemIndex(2)}
                >
                  <AccordionItemHeading>
                    <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                      <p className="font-semibold bodyLarger">Due Diligence Results</p>
                      <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>                    
                    <div className="w-full flex flex-col gap-4 mt-6">
                      <p className="bodyLarger"><b>Data Source Identified:</b> {ddToString(applicationDetails.ddObj.cat1)}</p>
                      <p className="bodyLarger"><b>General Eligibility Check:</b> {ddToString(applicationDetails.ddObj.cat2)}</p>
                      <p className="bodyLarger"><b>Best for Criteria:</b> {ddToString(applicationDetails.ddObj.cat3)}</p>
                      <p className="bodyLarger"><b>No Conflict of Interest:</b> {ddToString(applicationDetails.ddObj.cat4)}</p>
                      <p className="bodyLarger"><b>Security Checks:</b> {ddToString(applicationDetails.ddObj.cat5)}</p>
                      <p className="bodyLarger"><b>No Reputational Risk Found:</b> {ddToString(applicationDetails.ddObj.cat6)}</p>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
                }
                {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.expertMeetings && applicationDetails.expertAssessment.expertMeetings.length > 0 &&
                <AccordionItem
                  uuid={3}
                  className=""
                  key={`3`}
                  onClick={() => setChildClickedAccordionItemIndex(3)}
                  >
                  <AccordionItemHeading>
                      <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                        <p className="font-semibold bodyLarger">IP Expert Meetings</p>
                        <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  <AccordionItemPanel>
                  {
                      applicationDetails.expertAssessment.expertMeetings.map((meeting) => (
                        <div className="w-full flex flex-col gap-4">
                          <div className="w-full flex justify-between items-center my-2">
                            <p className="flex justify-between items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M0.976621 0.000509719C0.700221 0.00156869 0.459824 0.129712 0.282949 0.304455C0.108208 0.54168 -0.00510934 0.777847 0.000177378 1.00873C0.139969 5.09143 1.42987 8.35727 3.76188 10.591C6.09707 12.8277 9.45311 14.0076 13.6491 14C13.9192 13.9629 14.1808 13.8464 14.3481 13.6854C14.525 13.5107 14.6616 13.2745 14.6626 12.997C14.6701 12.0248 14.6775 11.0505 14.6838 10.0782C14.6764 9.80605 14.5419 9.58048 14.364 9.41103C14.1861 9.24159 13.9478 9.11558 13.6703 9.11769C12.7564 9.12087 11.5342 8.80209 10.5493 8.55746C10.437 8.52887 10.312 8.56275 10.2294 8.64324L8.50107 10.3186C6.39782 9.06792 5.4795 8.17622 4.19497 6.13536L5.91272 4.47056C5.99956 4.38583 6.03556 4.25134 6.0038 4.13484C5.74115 3.15099 5.28895 1.84097 5.36307 0.869812C5.3493 0.60611 5.12267 0.369932 4.95217 0.240747C4.77213 0.10625 4.53384 -0.00706801 4.25321 0.000344244H0.977615L0.976621 0.000509719ZM0.976621 0.683581H4.26822C4.34447 0.680404 4.44719 0.720648 4.54039 0.790544C4.62299 0.851967 4.67488 0.928218 4.68971 0.950458C4.64205 2.05609 5.03706 3.23164 5.287 4.12005L3.51522 5.84311C3.40296 5.95008 3.37966 6.13857 3.46227 6.2699C4.91422 8.62415 5.9563 9.63334 8.3762 11.045C8.50329 11.1202 8.68015 11.1001 8.78711 10.9974L10.5695 9.26374C11.5152 9.50202 12.6664 9.80702 13.6745 9.80279C13.7285 9.80279 13.8217 9.83668 13.8938 9.90446C13.9647 9.97224 13.9997 10.0612 14.0007 10.0961L13.9795 12.9938C13.9795 13.0372 13.9456 13.1294 13.8726 13.2014C13.7995 13.2734 13.6936 13.3147 13.6269 13.3189C9.57074 13.3221 6.41795 12.1868 4.2363 10.0962C2.05044 8.00141 0.814572 4.92715 0.683353 0.967256C0.68653 0.888888 0.740542 0.838053 0.769136 0.791454C0.825265 0.727911 0.912105 0.710966 0.976709 0.684492L0.976621 0.683581Z" fill="#1A2E25"/></svg>
                              {moment(meeting.date).format('MMM Do YYYY').toString()}
                            </p>
                            <p>{meeting.duration} minutes</p>
                            <p>{daysAgo(meeting.date)} days ago</p>
                          </div>
                          <p className="font-semibold">{meeting.meetingType}</p>
                          <p className="">{meeting.notes}</p>
                        </div>
                      ))
                      }
                      
                  </AccordionItemPanel>
                </AccordionItem>
                }
                {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.complete &&
                <AccordionItem
                  uuid={4}
                  className=""
                  key={`4`}
                  onClick={() => setChildClickedAccordionItemIndex(4)}
                  >
                  <AccordionItemHeading>
                      <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                        <p className="font-semibold bodyLarger">IP Expert Assessment</p>
                        <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  <AccordionItemPanel>
                  {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipRejectionObj &&
                    <div>
                      <div className="flex w-full flex-col gap-4 mr-2 mt-2">
                        <h4 className="">Reasoning:</h4>
                        <div className="w-full inline-flex flex-wrap">
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.hardCrit}
                                disabled={true}
                              />
                              <span className="ml-2">Hard Criteria</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.notTech}
                                disabled={true}
                              />
                              <span className="ml-2">Not Technology</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.economicBenefit}
                                disabled={true}
                              />
                              <span className="ml-2">Economic Benefit</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.revScore}
                                disabled={true}
                              />
                              <span className="ml-2">Revenue Source</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.marketReadiness}
                                disabled={true}
                              />
                              <span className="ml-2">Market Readiness</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.ipOwnership}
                                disabled={true}
                              />
                              <span className="ml-2">IP Ownership</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.commercialization}
                                disabled={true}
                              />
                              <span className="ml-2">Commercialization</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.jobCreation}
                                disabled={true}
                              />
                              <span className="ml-2">Job Creation</span>
                            </label>
                          </div>
                          <div className="flex bodyLarger my-2">
                            <label className="flex items-center h-full align-center">
                              <input
                                type="checkbox"
                                checked={applicationDetails.expertAssessment.ipRejectionObj.teamFit}
                                disabled={true}
                              />
                              <span className="ml-2">Team Fit</span>
                            </label>
                          </div>
                        </div>  
                      </div>
                    </div>
                  }
                  {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipAssessmentObj && 
                    <div className="overflow-y-auto flex flex-col w-full pr-2 mt-2">
                      <p className="font-semibold bodyLarger mb-4">Tier 1 - Education and Awareness</p>
                      {applicationDetails.expertAssessment.ipAssessmentObj.t1Rec === "n/a" ?
                        <div className="flex flex-col w-full mb-4">
                          Not Applicable
                        </div>
                      :
                      <Form 
                        readOnly={true}
                        disabled={true}
                        formDefinition={t1AssessmentForm}
                        formData= {{
                          t1Rec: applicationDetails.expertAssessment.ipAssessmentObj.t1Rec || "",
                          t1Score: applicationDetails.expertAssessment.ipAssessmentObj.t1Score || "",
                          t1Notes: applicationDetails.expertAssessment.ipAssessmentObj.t1Notes || "",
                        }}
                      />
                      }
                      <p className="font-semibold bodyLarger mb-4">Tier 2 - Coaching</p>
                      {applicationDetails.expertAssessment.ipAssessmentObj.t2CoachRec === "n/a" ?
                        <div className="flex flex-col w-full mb-4">
                          Not Applicable
                        </div>
                      :
                      <Form 
                        readOnly={true}
                        disabled={true}
                        formDefinition={t2CoachAssessmentForm}
                        formData= {{
                          t2CoachRec: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachRec || "",
                          t2CoachScore: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachScore || "",
                          t2CoachNotes: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachNotes || "",
                        }}
                      />
                      }
                      <p className="font-semibold bodyLarger mb-4">Tier 2 - Service</p>
                      {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceRec === "n/a" ?
                        <div className="flex flex-col w-full mb-4">
                          Not Applicable
                        </div>
                      :
                      <div className="w-full flex flex-col gap-2">
                        <Form
                          readOnly={true}
                          disabled={true} 
                          formDefinition={t2ServiceAssessmentForm}
                          formData= {{
                            t2ServiceRec: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceRec || "",
                            t2ServiceScore: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceScore || "",
                            t2ServiceNotes: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceNotes || "",
                          }}
                          />
                          {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray && applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray.length > 0 &&
                            <div className="flex flex-col gap-2 mb-6">
                              <p className="bodyLarger">Recommended Tier 2 Services</p>
                              <ul className="">
                                {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray.map((item) => (
                                  <li key={item}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          }
                      </div>
                      }
                      <p className="font-semibold bodyLarger mb-4">Tier 3 - Service</p>
                      {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceRec === "n/a" ?
                        <div className="flex flex-col w-full mb-4">
                          Not Applicable
                        </div>
                      :
                      <div className="w-full flex flex-col gap-2">
                        <Form 
                          readOnly={true}
                          disabled={true}
                          formDefinition={t3serviceAssessmentForm}
                          formData= {{
                            t3ServiceRec: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceRec || "",
                            t3ServiceScore: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceScore || "",
                            t3ServiceNotes: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceNotes || "",
                          }}
                        />
                        {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray && applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray.length > 0 &&
                          <div className="flex flex-col gap-2 mb-6">
                            <p className="bodyLarger">Recommended Tier 3 Services</p>
                            <ul className="">
                              {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray.map((item) => (
                                <li key={item}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        }
                        {
                          applicationDetails.expertAssessment.ipAssessmentObj.successStory && applicationDetails.expertAssessment.ipAssessmentObj.successStoryNotes &&
                          <div className="w-full flex flex-col gap-2 mb-6">
                            <p className="font-semibold">Success Story Notes</p>
                            <p>{applicationDetails.expertAssessment.ipAssessmentObj.successStoryNotes}</p>
                          </div>
                        }
                      </div>
                        }
                    </div>
                  }
                  </AccordionItemPanel>
                </AccordionItem>
                }
              </Accordion>
            {html}
        </div>
        </div>
        <div className="memDetailsCont2">
          <div className="w-full">
            {multipleOpenSows &&
              <div className="flex flex-col w-full gap-2 mb-4">
                <p className="bodyLarger font-semibold">This company has Multiple SoWs in this project</p>
                <div className="flex w-full">
                  <button className={sowViewingArrayPosition === 0 ? `font-semibold underline p-2` : `underline p-2`} onClick={() => setSowViewingArrayPostion(0)}>Statement 1</button>
                  <button className={sowViewingArrayPosition === 1 ? `font-semibold underline p-2` : `underline p-2`} onClick={() => setSowViewingArrayPostion(1)}>Statement 2</button>
                </div>
              </div>
            }
            {project &&
            <div>
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Awaiting Admin Approval" &&
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{returnFounderStatusStrings("sowAwaitingAdminApproval")[0]}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center"><div className={returnFounderStatusStrings("sowAwaitingAdminApproval")[1]}></div>{returnFounderStatusStrings("sowAwaitingAdminApproval")[2]}</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger mt-4">{returnFounderStatusStrings("sowAwaitingAdminApproval")[3]}</p>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                    <Button 
                      buttonText="Review SoW"
                      actionHandler={() => viewSow()}
                      buttonType="primaryFull"
                    />
                </div>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Awaiting Expert Approval" &&
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{returnFounderStatusStrings("sowAwaitingAdminApproval")[0]}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center">No Action Required at this time</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger my-4">{`The SoW is awaiting approval from ${applicationDetails?.expertAssessment?.assessorName || "the IP Expert who worked with the company"}`}</p>
                <div className="w-full">
                  <Button 
                    buttonText="Remove Admin Approval"
                    actionHandler={() => revokeAdminApproval()}
                    buttonType="primaryFull"
                  />
                </div>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Edit Requested from Admin" &&
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{returnFounderStatusStrings("sowEditRequested")[0]}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center"><div className={returnFounderStatusStrings("sowEditRequested")[1]}></div>{returnFounderStatusStrings("sowEditRequested")[2]}</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger mt-4">{returnFounderStatusStrings("sowEditRequested")[3]}</p>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                    <Button 
                      buttonText="Review SoW"
                      actionHandler={() => viewSow()}
                      buttonType="primaryFull"
                    />
                </div>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "New SoW Request" && 
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{returnFounderStatusStrings("sowRequested")[0]}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center"><div className={returnFounderStatusStrings("sowRequested")[1]}></div>{returnFounderStatusStrings("sowRequested")[2]}</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger mt-4">{returnFounderStatusStrings("sowRequested")[3]}</p>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Edit Request from Startup" &&
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{returnFounderStatusStrings("sowRequested")[0]}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center"><div className={returnFounderStatusStrings("sowRequested")[1]}></div>{returnFounderStatusStrings("sowRequested")[2]}</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger mt-4">{returnFounderStatusStrings("sowRequested")[3]}</p>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Awaiting Startup Approval" &&
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{returnFounderStatusStrings("sowAwaitingStartupApproval")[0]}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center"><div className={returnFounderStatusStrings("sowAwaitingStartupApproval")[1]}></div>{returnFounderStatusStrings("sowAwaitingStartupApproval")[2]}</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger mt-4">{returnFounderStatusStrings("sowAwaitingStartupApproval")[3]}</p>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Approved & Ready for Signatures" &&
              <div>
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{"SoW Ready for Signature"}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center"><div className={"orangeCircle"}></div>{"Initiate Signatures"}</p>
                      </div>
                  </div>
                </div>
                <p className="bodyLarger mt-4">{"Please gather all required signatures so work may proceed."}</p>
                <div className="flex flex-col gap-8 mt-4">
                  <Button 
                    buttonText="View and Export SoW Pdf"
                    actionHandler={() => viewSow()}
                  />
                  {memberDetailsAsync.value.project && 
                  <Button 
                  buttonText="Mark SoW as Signed"
                  actionHandler={() => markSowSigned()}
                  />
                  }
                </div>
              </div>
            }
            {
              project?.statements[sowViewingArrayPosition].sowStatus === "Ready to Begin Work" &&
                <div className="flex justify-between w-full gap-2">
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Status:</h4>
                    <p className="bodyLarger">{"Ready to Begin Work"}</p>
                  </div>
                  <div className="flex flex-col w-1/2 gap-2">
                    <h4 className="font-semibold">Action Item:</h4>
                      <div className="flex flex-wrap items-center">   
                        <p className="bodyLarger break-word flex items-center">No Action Required</p>
                      </div>
                  </div>
                </div>
            }
            </div>
            }
            {!project &&
            <div className="flex justify-between w-full gap-2">
              <div className="flex flex-col w-1/2 gap-2">
                <h4 className="font-semibold">Status:</h4>
                <p className="bodyLarger">{statusStrings[0]}</p>
              </div>
              <div className="flex flex-col w-1/2 gap-2">
                <h4 className="font-semibold">Action Item:</h4>
                  {statusStrings[1] 
                  ? 
                  <div className="flex flex-wrap items-center">    
                    <p className="bodyLarger break-word flex items-center"><div className={statusStrings[1]}></div>{statusStrings[2]}</p>
                  </div>
                  :
                  <p className="bodyLarger text-cSecondaryGreen">No action required</p>
                  }
              </div>
            </div>
            }
            {
              !project &&
              statusStrings[3] && 
              <p className="bodyLarger mt-4">{statusStrings[3]}</p>
            }
            {/* STATUS SPECFIC BUTTONS */}
            {
              founderStatus === "rejectedFlagged" && applicationDetails &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Complete Rejection Email"
                  actionHandler={() => setIsRejectionModalOpen(true)}
                  buttonType="primaryFull"
                />
              </div>
            }
            {
              founderStatus === "rejectedInProgress" && applicationDetails &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Complete Rejection Email"
                  actionHandler={() => rejectionProgCheck()}
                  buttonType="primaryFull"
                />
              </div>
            }
            {
              founderStatus === "pending" && applicationDetails &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Begin Due Diligence"
                  actionHandler={() => navigate(`/dashboard/membership-applications/${applicationDetails._id}`)}
                  buttonType="primaryFull"
                />
              </div>
            }
            {
              founderStatus === "submitted" && applicationDetails &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Begin Due Diligence"
                  actionHandler={() => navigate(`/dashboard/membership-applications/${applicationDetails._id}`)}
                  buttonType="primaryFull"
                />
              </div>
            }
            {
              founderStatus === "ddInProgress" && applicationDetails &&
              <div className="w-full mt-8">
                <Button 
                  buttonText="Continue Due Diligence"
                  actionHandler={() => navigate(`/dashboard/membership-applications/${applicationDetails._id}`)}
                  buttonType="primaryFull"
                />
              </div>
            }
            {
              founderStatus === "pendingEditRequest" && applicationDetails &&
              <div className="w-full mt-8">
              </div>
            }
            {
              founderStatus === "growthCoachInvite" &&
              <div className="w-full flex flex-col mt-2 gap-2">
                <p>{gcInviteString}</p>
                <Button         
                  buttonType="primaryFull"
                  buttonText="Request Application Edit"
                  actionHandler={ () => {
                    editRequest()
                  }}
                />
              </div>
            }
            {
              founderStatus === "growthCoachInProgress" &&
              <div className="w-full flex flex-col mt-2 gap-2">
                {
                  memberDetailsAsync.value.gcName !== "N/A" &&
                  <p>This company has been claimed for review by {memberDetailsAsync.value.gcName}</p>
                }
                <Button         
                  buttonType="primaryFull"
                  buttonText="Request Application Edit"
                  actionHandler={ () => {
                    editRequest()
                  }}
                />
              </div>
            }
            {
              founderStatus === "screened" &&
              <div>
                <div className="w-full mt-8 gap-4 flex flex-col flex-wrap">
                    <Button 
                      buttonText="Initiate IPE Invitaion"
                      actionHandler={() => handleIpeSatusUpdate()}
                      buttonType="primaryFull"
                    />
                    <Button 
                      buttonText="Request GC Assessment"
                      actionHandler={() => handleGrowthCoachModal()}
                      buttonType="primaryFull"
                    />
                    <Button 
                      buttonText="Flag for Rejection"
                      actionHandler={() => flagForRejection()}
                      buttonType="secondaryFull"
                    />
                </div>
              </div>
            }
            {
              founderStatus === "growthCoachRecommendation" &&
              <div>
                {/* {applicationDetails?.growthCoach?.declineReason ?
                <p className="bodyLarger mt-4">The Growth Coach has responded with the rejection reason <span className="font-semibold">{applicationDetails?.growthCoach?.declineReason}</span>.  Please select a path forward with the buttons below.</p>
                :
                <p className="bodyLarger mt-4">The Growth Coach has responded with <span className="font-semibold">No Concerns</span>.  Additional feedback is be present in the Internal Notes.</p>
                } */}
                <div className="w-full mt-8 flex flex-wrap">
                  <div className="w-1/2 inline-flex pr-2">
                    <Button 
                      buttonText="IPE Invitaion"
                      actionHandler={() => handleIpeSatusUpdate()}
                      buttonType="primaryFull"
                    />
                  </div>
                  <div className="w-1/2 inline-flex pl-2">
                    <Button 
                      buttonText="Tier 1 Only"
                      actionHandler={() => setIsRejectionModalOpen(true)}
                      buttonType="primaryFull"
                    />
                  </div>
                </div>
                  <Button         
                    buttonType="primaryFull"
                    buttonText="Request Application Edit"
                    actionHandler={ () => {
                      editRequest()
                    }}
                  />
              </div>
            }
            {
              founderStatus === "ipExpertRecommendation" &&
              <div>
                <div className="w-full mt-8 flex flex-wrap flex-col gap-2">
                    <Button 
                      buttonText="View Recommendation"
                      actionHandler={() => handleViewRec()}
                      buttonType="primaryFull"
                    />
                    <Button         
                      buttonType="primaryFull"
                      buttonText="Request Application Edit"
                      actionHandler={ () => {
                        editRequest()
                      }}
                    />
                </div>
              </div>
            }
            {
              founderStatus === "dueDiligence" &&
              <div>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                    <Button 
                      buttonText="Initiate IPE Invitaion"
                      actionHandler={() => navigate("/dashboard/admin-expert-preinvite")}
                      buttonType="primaryFull"
                    />
                    <Button 
                      buttonText="Request GC Assessment"
                      actionHandler={() => handleGrowthCoachModal()}
                      buttonType="primaryFull"
                    />
                    <Button 
                      buttonText="Tier 1 Only"
                      actionHandler={() => handleReject()}
                      buttonType="primaryFull"
                    />
                    <Button         
                      buttonType="primaryFull"
                      buttonText="Request Application Edit"
                      actionHandler={ () => {
                        editRequest()
                      }}
                    />
                </div>
              </div>
            }
            {
              founderStatus === "newSpfRequested" && 
              <div>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                  <Button 
                    buttonText="Select Provider"
                    actionHandler={() => setSelectSpf(true)}
                    buttonType="primaryFull"
                  />
                </div>
              </div>
            }
            {/* {
              founderStatus === "sowAwaitingApproval" && !multipleOpenSows &&
              <div>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                    <Button 
                      buttonText="Review SoW"
                      actionHandler={() => viewSow()}
                      buttonType="primaryFull"
                    />
                </div>
              </div>
            }
            {
              founderStatus === "sowAwaitingAdminApproval" && !multipleOpenSows &&
              <div>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                    <Button 
                      buttonText="Review SoW"
                      actionHandler={() => viewSow()}
                      buttonType="primaryFull"
                    />
                </div>
              </div>
            }
            {
              founderStatus === "sowEditRequested" && !multipleOpenSows &&
              <div>
                <div className="w-full mt-8 gap-4 flex flex-wrap">
                    <Button 
                      buttonText="Review SoW"
                      actionHandler={() => viewSow()}
                      buttonType="primaryFull"
                    />
                </div>
              </div>
            } */}
            <div className="w-full mt-4 gap-4 flex flex-wrap">
            {!project &&
              <Button         
                buttonType="primaryFull"
                buttonText="Request Application Edit"
                actionHandler={ () => {
                  editRequest()
                }}
              />
              }
            </div>
          </div>
          <div className="memDetailsCont2Inner">
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Application</p>
                {applicationDate !== null ?
                <p>{moment(applicationDate).format('MMM Do YYYY').toString()}</p>
                :
                <p className="">Unsubmitted</p>
                }
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Touch Point</p>
                {founderStatus === "n/a" ?
                <p className="text-cSecondaryGreen">N/A</p>
                :
                <p className="text-cSecondaryGreen">N/A</p>
                }
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Status</p>
                <p>{statusStrings[0]}</p>
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Cohort</p>
                <p>{cohort}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Screened</p>
                {applicationDetails 
                  && applicationDetails.status !== "pending" 
                  && applicationDetails.status !== "submitted" 
                  && applicationDetails.status !== "rejected" 
                  && applicationDetails.status !== "rejectedFlagged" 
                  && applicationDetails.status !== "rejectedInProgress" 
                  ?
                <p>Yes</p>
                :
                <p className="">No</p>
                }
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Due Diligence</p>
                {applicationDetails && applicationDetails.ddObj && applicationDetails.status !== "rejected" && applicationDetails.status !== "rejectedInProgress" ?
                <p>Complete</p>
                :
                <p>Incomplete</p>
                }
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Owner</p>
                <p className={ownerString === "N/A" ? "text-cSecondaryGreen" : ""}>{ownerString}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">GC</p>
                <p className={gcString === "N/A" ? "text-cSecondaryGreen" : ""}>{gcString}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">IPE</p>
                <p className={ipeString === "N/A" ? "text-cSecondaryGreen" : ""}>{ipeString}</p>
              </div>
            </div>
            {memberDetailsAsync.value.awaitingApprovalStatements && 
            <div className="flex justify-between w-full">
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Tier</p>
                <p>{memberDetailsAsync.value.tier}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">SP</p>
                <p className="pr-2">{memberDetailsAsync.value.provider}</p>
              </div>
              <div className="w-1/3 flex flex-col">
                <p className="bodyLarger font-semibold">Co-Invest %</p>
                <p>{memberDetailsAsync.value.coInvestPercentage}</p>
              </div>
            </div>
            }
            <div className="flex flex-col w-full">
              <p className="bodyLarger font-semibold w-full">Files</p>
              {docHtml}
            </div>
          </div>
        </div>
      </div>
      <Modal 
        isOpen={isModalOpen}
        closeModal={() => modalClose()}
        modalHeader={""}
        contentLabel={""} // [TODO]
        fullWidth={true}
        modalHTML={modalHtml}
        style={
          viewingSow ? 
          {content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: `90vw`,
            maxHeight: '90%',
            background: "background",
          }}
          :
          viewPdfName === "" && founderStatus !== "sowAwaitingApproval" && founderStatus !== "sowAwaitingAdminApproval" ?
          {content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '300px',
            width: 'fit-content',
            maxWidth: '800px',
            maxHeight: '80%',
            background: "background",
          }}
          :
          founderStatus === "sowAwaitingAdminApproval" && modalHtml !== sowFeedbackHTML ?
          {content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              minWidth: '300px',
              width: 'calc(100% - 112px',
              height: "90vh",
              overflow: "auto",
              background: "background",
            }}
          :
          {content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '300px',
            width: 'full',
            background: "background",
          }}
        }
        />
    </div>
  )
}

export default MemberDetails